/**
 * @mui/private-theming v9.3.0
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
export { default as ThemeProvider } from "./ThemeProvider/index.mjs";
export * from "./ThemeProvider/index.mjs";
export { default as useTheme } from "./useTheme/index.mjs";